import Api from 'libs/api';
import AuthService from 'services/Auth';

class MessagesApi extends Api {
  constructor(restaurantId) {
    const resId = restaurantId || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/messages`);
  }
}

export default MessagesApi;
